import React from 'react';

import './Forms.scss';

const FormFooter: React.FC<{}> = props => {
  return <div className="formFooter">{props.children}</div>;
};

export default FormFooter;
